import React, { useEffect } from 'react';
import '../styles/ubuntu2410.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "Ubuntu 24.10 U1",
    discount: "DEV SNAPSHOT",
    price: "$5.49",
    subtitle: "Experimental build for developers and testers.",
    features: [
      "Ubuntu 24.10 Dev",
      "1 vCPU",
      "1GB RAM",
      "25GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "1000GB Bandwidth",
      "Snapshot Support",
      "DDoS Protection",
      "Instant Rebuild",
    ],
  },
  {
    name: "Ubuntu 24.10 U2",
    discount: "BETA BUILD",
    price: "$9.49",
    subtitle: "Testing and QA VPS for new Ubuntu tech stack.",
    features: [
      "Ubuntu 24.10 Dev",
      "2 vCPU",
      "2GB RAM",
      "90GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "3000GB Bandwidth",
      "Snapshot Support",
      "DDoS Protection",
      "Instant Rebuild",
    ],
  },
  {
    name: "Ubuntu 24.10 U3",
    discount: "ADVANCED DEV",
    price: "$14.49",
    subtitle: "High-spec server for continuous preview builds.",
    features: [
      "Ubuntu 24.10 Dev",
      "4 vCPU",
      "4GB RAM",
      "180GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "6000GB Bandwidth",
      "Snapshot Support",
      "DDoS Protection",
      "Instant Rebuild",
    ],
  },
];

function Ubuntu2410() {
  useEffect(() => {
    document.body.classList.add('ubuntu2410-page');
    return () => {
      document.body.classList.remove('ubuntu2410-page');
    };
  }, []);

  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/mo</span></span>
            </p>
            <a href="#" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Ubuntu2410;
